import React from "react";
import "../styles/AboutUsBanner.css";
import myvideo from '../assets/usecases-banner.mp4'

const UseCaseBanner = () => {
  return (
    <section className="about-us-banner">
      <video
        className="aboutus-banner-video"
        src={myvideo}
        autoPlay
        loop
        muted
      ></video>
      <div className="aboutus-overlay">
        <div className="aboutus-content">
          <h1>Industries We Transform with Robotics Automation</h1>
          <p>Empowering businesses with innovative robotic solutions across sectors.</p>
        </div>
      </div>
    </section>
  );
};

export default UseCaseBanner;
